import _react, { useState, useEffect } from "react";

export default function TypingEffect(props) {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (index === props.text.length) return;
        const timeout = setTimeout(() => {
            setIndex((prev) => prev + 1);
        }, props.delay);
        return () => clearTimeout(timeout);
    }, [index]);

    const text = props.text.substring(0, index);

    return (
        <li>
            {props.baseText}
            {text}
        </li>
    );
};
